import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Atto } from '../../../models/atto';

@Component({
    selector: '[add_doc_to_atto]',
  templateUrl: 'add-to-atto.component.html',
})

export class AddDocumentoToAttoComponent {
  @Input()
  atto: Atto;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(atto: Atto) {
    this.onClickAddToEntity.emit(atto);
  }
}
